module.exports = __webpack_public_path__ + "img/bullseye.e0503ada.svg";